module.exports = __webpack_public_path__ + "img/bg_main05_mask_m.6bc6a080.png";